import { STANDS_AGENTS } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/constants/StandsAgents';
import { StandsAgentMap } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/maps/standsAgent.map';
import { useUser } from '@/hooks/useUser';

export const useStandsAgent = () => {
  const { userEntity } = useUser();

  // The username is the login email
  const standsAgent = StandsAgentMap.findByEmail(STANDS_AGENTS, userEntity?.user.username);

  return {
    standsAgent,
  };
};
